import React from "react";
import ReactDOM from "react-dom/client";
import "./style/scss/index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./theme/ThemeProvider";

document.title = import.meta.env.VITE_DOCUMENT_TITLE || "Career Master";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
   <ErrorBoundary>
    <React.StrictMode>
      <BrowserRouter>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>
    </ErrorBoundary> 
);